@if (!renderEmpty) {
<div
  class="grid"
  [style]="{
    'grid-template-columns': gridTemplateColumns,
    'grid-template-rows': gridTemplateRows,
    gap: gap
  }"
>
  <ng-content></ng-content>
</div>
} @if (renderEmpty) {
<div></div>
}
